import memoize from "lodash/memoize";

const _ = { memoize };

function getAvailability(availability) {
  const list = availability && availability.list
    .reduce((m, a) => m.concat(a.offerings), [])
    .map(o => ({
      price: parseInt(o.cost.amount, 10),
      currency: o.cost.currency,
    }))
    .sort((a, b) => a.price - b.price)[0];

  return {
    startDate: availability.startDate,
    endDate: availability.endDate,
    price: list && list.price,
    currency: list && list.currency,
    fetching: availability.fetching,
    numNights: parseInt(availability.numNights, 10),
  };
}

export default _.memoize(getAvailability);



// WEBPACK FOOTER //
// ./assets/pois/selectors/getAvailability.js